// src/components/Login/ErrorModal.tsx
import React from 'react'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next'

interface ErrorModalProps {
  message: string
  onClose: () => void
}

const ErrorModal: React.FC<ErrorModalProps> = ({ message, onClose }) => {
  const { t } = useTranslation()

  if (typeof document === 'undefined') return null

  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Fondo semi-transparente */}
      <div
        className="absolute inset-0 bg-black/70"
        onClick={onClose}
      />

      {/* Contenido del modal */}
      <div className="relative z-10 bg-gray-800 rounded-xl shadow-xl p-6 max-w-sm w-full mx-4 text-white">
        <h2 className="text-2xl font-bold mb-4">
          {t('login.errorModal.title')}
        </h2>
        <p className="mb-6">{message}</p>
        <div className="text-right">
          <button
            type="button"
            onClick={onClose}
            className="
              inline-flex items-center gap-2
              bg-gradient-to-r from-red-500 to-red-600
              hover:from-red-600 hover:to-red-700
              text-white font-semibold
              px-4 py-2 rounded-lg
              shadow-md shadow-red-900/50
              transition-transform transform hover:scale-105
            "
          >
            {t('login.errorModal.retry')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default ErrorModal
